module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-plano-in-allen-texas-2ae0047996a92d2680b0895ce07a7054.png";